var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var header = ref.header;
var item = ref.item;
var v = ref.value;
return [_c('router-link',{attrs:{"to":header.getRoute(item)},domProps:{"textContent":_vm._s(v)}})]}},{key:"item.ates",fn:function(ref){
var v = ref.value;
return [_c('BTableItemAte',{attrs:{"data":v}})]}},{key:"item.is_published",fn:function(ref){
var v = ref.value;
return [(v)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" mdi-checkbox-marked-outline ")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v(" mdi-close-circle-outline ")])]}},{key:"item.is_updated",fn:function(ref){
var v = ref.value;
return [(v)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" mdi-checkbox-marked-outline ")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v(" mdi-close-circle-outline ")])]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }